import BrandBadge from "@/app/ui/atomic/content/BrandBadge";
import GoldPinkTitle from "@/app/ui/atomic/content/GoldPinkTitle";

interface EconChangersProps {
  coop?: boolean;
  coops?: boolean;
  punc?: string;
  space?: boolean;
  small?: boolean;
}

export function EconChangers({ coop, coops, punc, space, small }: EconChangersProps) {
  const suffix = coop ? " Co-Op" : coops ? " Co-Ops" : "";
  return (
    <BrandBadge
      goldText="Econ"
      pinkText={`Changers${suffix}`}
      punc={punc}
      space={space}
      small={small}
    />
  );
}

interface FlockWordProps {
  word: string;
  punc?: string;
  space?: boolean;
  small?: boolean;
}

export function FlockWord({ word, punc, space, small }: FlockWordProps) {
  return (
    <BrandBadge
      goldText="Flock"
      pinkText={word}
      punc={punc}
      space={space}
      small={small}
    />
  );
}

interface HeadingProps {
  prefix?: string;
  gold: string;
  pink: string;
  noSpace?: boolean;
  as?: "h2" | "h3";
}

export function Heading({ prefix, gold, pink, noSpace, as = "h2" }: HeadingProps) {
  return (
    <div className="px-6 md:px-12 py-8 lg:py-10 bg-gradient-purple">
      <div className="fast-text container mx-auto text-center">
        <GoldPinkTitle prefix={prefix} goldText={gold} pinkText={pink} noSpace={noSpace} as={as} />
      </div>
    </div>
  );
}
